import React from "react";
import useTimer from "./Timer";

const ClaimButton = ({ targetTime, fetchUsersNFTs }) => {
  const { timeLeft, formatTime } = useTimer(targetTime, fetchUsersNFTs);

  if (timeLeft <= 0) {
    fetchUsersNFTs();
    return null; // Avoid showing the timer when time has elapsed
  }

  return <div>{formatTime(timeLeft)}</div>;

  // return (
  //   <>
  //     {timeLeft > 0 ? (
  //       <div>{formatTime(timeLeft)}</div>
  //     ) : timeLeft == 0 ? (
  //       <>
  //         {fetchUsersNFTs}
  //         {/* <p>timer is zero</p> */}
  //       </>
  //     ) : (
  //       <button
  //         style={{
  //           display: "flex",
  //           padding: "7px 14px",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           gap: "10px",
  //           borderRadius: "30px",
  //           background: "#FF8A00",
  //           color: "#FFF",
  //           fontSize: "12px",
  //           fontStyle: "normal",
  //           fontWeight: 600,
  //           lineHeight: "100%",
  //           border: "none",
  //           outline: "none",
  //         }}
  //         onClick={handleClaimClick}
  //       >
  //         {/* {timeLeft} */}
  //         Claim
  //       </button>
  //     )}
  //   </>
  // );
};

export default ClaimButton;
